<template ref="overviewSection">
  <div id="education-wrapper">
    <notifications></notifications>
    <navbar />
    <div class="overview-outer-wrapper">
      <div
        id="overview-container"
        :class="{ 'full-height': view === 'Month' }"
      >
        <div id="action-bar-head-container">
          <div class="action-bar">
            <!-- Button for opening create new modal. used, when backend layer is fully changed to take new implementation of post request. -->
            <div>
              <b-button
                variant="success"
                size="sm"
                v-if="berechtigungen.m_ressourcen.create"
                class="ml-2"
                @click="openNewAppointmentModal()"
                v-tooltip.hover.text="$t('global.createnewappointment')"
              >
                <font-awesome-icon
                  :icon="['fa-regular', 'fa-calendar-circle-plus']"
                />
              </b-button>
              <b-button
                variant="outline-primary"
                size="sm"
                class="ml-2"
                @click="showToday()"
                v-tooltip.hover.text="$t('global.today')"
              >
                <font-awesome-icon :icon="['fa-duotone', 'fa-calendar-day']" />
              </b-button>
              <b-button
                @click="
                  showFilters ? (showFilters = false) : (showFilters = true)
                "
                class="m-0 ml-2"
                variant="outline-primary"
                size="sm"
                v-tooltip.hover.text="
                  showFilters
                    ? $t('global.hideFilters')
                    : $t('global.showFilters')
                "
              >
                <font-awesome-icon
                  class="mr-1"
                  icon="fa-regular fa-sliders-simple"
                  size="sm"
                />
                <font-awesome-icon
                  :icon="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"
                />
              </b-button>
            </div>

            <div class="content-right">
              <b-button
                @click="decrementDateRange"
                variant="outline-primary"
                size="sm"
              >
                <fa-icon :icon="['fas', 'arrow-left']" />
              </b-button>
              <div class="date-range">
                <span
                  v-if="!showDatePicker"
                  class="date-range-label"
                  @click="openDatePicker"
                  title="Klicken zum Datum eingeben"
                >
                  {{ currentDateRange }}
                </span>
                <input
                  v-else-if="view === 'Month'"
                  ref="datePicker"
                  type="month"
                  :value="monthPickerValue"
                  class="date-picker-input"
                  @change="jumpToDate($event.target.value)"
                  @blur="showDatePicker = false"
                  @keydown.escape="showDatePicker = false"
                />
                <input
                  v-else
                  ref="datePicker"
                  type="date"
                  :value="datePickerValue"
                  class="date-picker-input"
                  @change="jumpToDate($event.target.value)"
                  @blur="showDatePicker = false"
                  @keydown.escape="showDatePicker = false"
                />
              </div>
              <b-button
                @click="incrementDateRange"
                variant="outline-primary"
                size="sm"
              >
                <fa-icon :icon="['fas', 'arrow-right']" />
              </b-button>
            </div>
            <div>
              <v-select
                id="anzeigemodus"
                :options="dayIntervalOptions"
                :reduce="(o) => o.value"
                :get-option-label="(o) => o.label"
                v-model.number="dayIntervalLocal"
                :clearable="false"
                :searchable="false"
                class="select-wrap mr-1"
              />
              <!-- <label
                for="anzeigemodus"
                class="select-label"
              >
                {{ $t('global.displaymode') }}
              </label> -->
            </div>
            <div v-if="view === 'Day'">
              <v-select
                id="time-interval"
                :options="timeIntervalOptions"
                :get-option-label="(o) => o.label"
                :reduce="(o) => o.value"
                v-model.number="timeIntervalLocal"
                :clearable="false"
                class="select-wrap mr-2"
              />
              <!-- <label
                for="time-interval"
                class="select-label"
              >
                {{ $t('global.minutes') }}
              </label> -->
            </div>
          </div>
          <div
            v-if="showFilters"
            class="action-bar mt-3 ml-2"
          >
            <v-select
              class="multi-select-wrap mr-1"
              :options="raeume"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.room')"
              multiple
              v-model="tempRoomSelection"
            >
              <span slot="no-options">{{ $t('global.noroomfound') }}</span>
            </v-select>
            <v-select
              class="multi-select-wrap mr-1"
              :options="persons"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.person')"
              :loading="selectionValueIsLoading"
              multiple
              v-model="tempPersonSelection"
            >
              <template #loading>
                <span>{{ $t('global.loading') }}</span>
              </template>
              <template #no-options>
                <span>{{ $t('global.taptosearch') }}</span>
              </template>
            </v-select>
            <v-select
              class="multi-select-wrap mr-1"
              :options="subjects"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.Subject')"
              :loading="selectionValueIsLoading"
              multiple
              v-model="tempSubjectSelection"
            >
              <template #loading>
                <span>{{ $t('global.loading') }}</span>
              </template>
              <template #no-options>
                <span>{{ $t('global.taptosearch') }}</span>
              </template>
            </v-select>
            <v-select
              class="multi-select-wrap mr-1"
              :options="courses"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.course')"
              :loading="selectionValueIsLoading"
              multiple
              v-model="tempCourseSelection"
            >
              <template #loading>
                <span>{{ $t('global.loading') }}</span>
              </template>
              <template #no-options>
                <span>{{ $t('global.taptosearch') }}</span>
              </template>
            </v-select>
            <v-select
              class="multi-select-wrap mr-1"
              :options="shortevents"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.shortevent')"
              :loading="selectionValueIsLoading"
              multiple
              v-model="tempShortEventSelection"
            >
              <template #loading>
                <span>{{ $t('global.loading') }}</span>
              </template>
              <template #no-options>
                <span>{{ $t('global.taptosearch') }}</span>
              </template>
            </v-select>
            <v-select
              class="multi-select-wrap mr-1"
              :options="educationalCourses"
              :reduce="(s) => s.id"
              label="bezeichnung"
              :placeholder="$t('global.educationcourse')"
              :loading="selectionValueIsLoading"
              multiple
              v-model="tempEducationalCourseSelection"
            >
              <template #loading>
                <span>{{ $t('global.loading') }}</span>
              </template>
              <template #no-options>
                <span>{{ $t('global.taptosearch') }}</span>
              </template>
            </v-select>
            <!-- div darunter soll ganz rechts sein -->
            <div
              v-if="view === 'Day'"
              class="ml-auto d-flex flex-column align-items-end vp-compact-check"
            >
              <label class="mb-0 d-flex align-items-center">
                <input
                  type="checkbox"
                  v-model="showSaturday"
                  class="mr-1"
                />
                <span>{{ $t('global.showsaturday') }}</span>
              </label>
              <label class="mb-0 d-flex align-items-center">
                <input
                  type="checkbox"
                  v-model="showSunday"
                  class="mr-1"
                />
                <span>{{ $t('global.showsunday') }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="filter-summary-list ml-2">
          <div
            v-if="selectedRooms.length"
            class="filter-summary mt-1"
          >
            <strong>{{ $t('global.room') }}:</strong>
            <span
              v-for="id in selectedRooms"
              :key="id"
              class="filter-chip"
            >
              {{ raeume.find((r) => r.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removeRoom(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
          </div>
          <div
            v-if="selectedPersons.length"
            class="filter-summary mt-1"
          >
            <strong>{{ $t('global.person') }}:</strong>
            <span
              v-for="id in selectedPersons"
              :key="id"
              class="filter-chip"
            >
              {{ persons.find((p) => p.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removePerson(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
          </div>
          <div
            v-if="
              selectedSubjects.length > 0 ||
              selectedCourses.length > 0 ||
              selectedShortEvents.length > 0 ||
              selectedEducationalCourses.length > 0
            "
            class="filter-summary mt-1"
          >
            <strong>{{ $t('global.event') }}:</strong>
            <span
              v-for="id in selectedSubjects"
              :key="id"
              class="filter-chip"
            >
              {{ subjects.find((s) => s.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removeSubject(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
            <span
              v-for="id in selectedCourses"
              :key="id"
              class="filter-chip"
            >
              {{ courses.find((c) => c.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removeCourse(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
            <span
              v-for="id in selectedShortEvents"
              :key="id"
              class="filter-chip"
            >
              {{ shortevents.find((se) => se.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removeShortEvent(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
            <span
              v-for="id in selectedEducationalCourses"
              :key="id"
              class="filter-chip"
            >
              {{ educationalCourses.find((ec) => ec.id === id)?.bezeichnung }}
              <button
                class="chip-remove"
                @click="removeEducationalCourse(id)"
                title="Entfernen"
              >
                <font-awesome-icon icon="fa-regular fa-xmark" />
              </button>
            </span>
          </div>
        </div>
        <div
          v-if="view === 'Day'"
          class="day-view"
        >
          <div class="visual-planner-head-container">
            <div class="visual-planner-header">
              <div class="header-empty-cell"></div>
              <!-- HEADERS -->
              <div
                v-for="(vIndex, pos) in visibleIndices"
                :key="'dh-' + vIndex"
                class="interval-column-head"
                :class="{
                  'is-past': isPastDate(
                    getDateByIndexAndStartDate(vIndex, requestStartDate)
                  ),
                  'is-today': isTodayDate(
                    getDateByIndexAndStartDate(vIndex, requestStartDate)
                  ),
                }"
                :style="{
                  left: `${(100 / layoutDayInterval) * pos}%`,
                  width: `${100 / layoutDayInterval}%`,
                }"
                @click="
                  openDayFromWeek(
                    getDateByIndexAndStartDate(vIndex, requestStartDate)
                  )
                "
              >
                <div class="day">
                  <div class="day-text">
                    {{
                      safeDayName(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    }}
                  </div>
                  <div class="day-number">
                    {{
                      safeDayNumber(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    }}
                  </div>
                </div>
                <div class="conflict-indicators">
                  <div
                    v-if="
                      hasPersonConflictsDate(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    "
                    @click.stop="
                      setPeopleConflictsFilter(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    "
                    class="conflict-indicator person"
                    title="Click to select all conflicting Resources"
                  >
                    <fa-icon :icon="['fas', 'fa-user']" />
                  </div>
                  <div
                    v-if="
                      hasRoomConflictsDate(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    "
                    @click.stop="
                      setRoomConflictsFilter(
                        getDateByIndexAndStartDate(vIndex, requestStartDate)
                      )
                    "
                    class="conflict-indicator room"
                    title="Click to select all conflicting Resources"
                  >
                    <fa-icon :icon="['fad', 'fa-building']" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            id="overview"
            :style="{
              'max-height': calcRowCountFromTimeInterval * 24 + 1 + 'px',
            }"
          >
            <div class="visual-planner-body">
              <div id="visual-planner-side-bar">
                <div
                  v-for="index in calcRowCountFromTimeInterval"
                  :key="'r-' + index"
                  :class="[
                    'background-row',
                    index % calcTimeModulo !== 0 ? 'background-row-dashed' : '',
                  ]"
                  :style="{
                    top: `${
                      (index - 1) * (100 / calcRowCountFromTimeInterval)
                    }%`,
                  }"
                >
                  <p
                    v-if="(index - 1) % calcTimeModulo === 0"
                    class="sidebar-hour"
                  >
                    {{ ((index - 1) / calcTimeModulo).toFixed(0) }}
                  </p>
                </div>
              </div>
              <div
                v-if="!isLoading"
                id="visual-planner-container"
                @click="handleClick"
              >
                <div
                  v-for="index in calcRowCountFromTimeInterval"
                  :key="'t-' + index"
                  :class="[
                    'background-row',
                    index % calcTimeModulo !== 0 ? 'background-row-dashed' : '',
                  ]"
                  :style="{
                    top: `${
                      (index - 1) * (100 / calcRowCountFromTimeInterval)
                    }%`,
                  }"
                ></div>
                <!-- Past-day background overlays -->
                <div
                  v-for="(vIndex, pos) in visibleIndices"
                  :key="'bg-' + vIndex"
                  class="interval-column-bg"
                  :class="{
                    'is-past': isPastDate(
                      getDateByIndexAndStartDate(vIndex, requestStartDate)
                    ),
                  }"
                  :style="{
                    left: `${(100 / layoutDayInterval) * pos}%`,
                    width: `${100 / layoutDayInterval}%`,
                  }"
                />

                <!-- Current time indicator -->
                <!-- Jetzt-Linie: links gestrichelt bis zum Punkt -->
                <div
                  v-if="showNowLine"
                  class="now-line-left"
                  :style="{
                    top: `${nowTopPercent}%`,
                    width: `${nowLeftPercent}%`,
                  }"
                />

                <!-- Jetzt-Linie: rechts durchgezogen ab Punkt -->
                <div
                  v-if="showNowLine"
                  class="now-line-right"
                  :style="{
                    top: `${nowTopPercent}%`,
                    left: `${nowLeftPercent}%`,
                  }"
                />

                <!-- Punkt auf Höhe der aktuellen Zeit am Beginn der heutigen Spalte -->
                <div
                  v-if="showNowLine && todayIndexInRange !== null"
                  class="now-bullet"
                  :style="{
                    top: `${nowTopPercent}%`,
                    left: `${nowLeftPercent}%`,
                  }"
                />
                <day-column
                  v-for="(vIndex, pos) in visibleIndices"
                  :key="'dc-' + vIndex"
                  :date="getDateByIndexAndStartDate(vIndex, requestStartDate)"
                  :index="pos"
                  :layout-day-interval="layoutDayInterval"
                />
              </div>
            </div>
          </section>
        </div>
        <div
          v-if="view === 'Month'"
          class="month-view"
        >
          <div class="calendar-layout">
            <div class="week-numbers">
              <div class="week-header"></div>
              <div class="week-column">
                <div
                  class="week-cell"
                  v-for="weekNum in getWeekNumbers()"
                  :key="'week-' + weekNum"
                  :style="{ height: `${cellHeight}px` }"
                  @click.stop="openWeek(weekNum)"
                >
                  <div class="week-content">
                    <div class="rotated-text">
                      {{ $t('global.week') }} {{ weekNum }}
                    </div>
                  </div>
                  <fa-icon
                    v-if="hasWeekConflicts(weekNum)"
                    :icon="['fad', 'exclamation-triangle']"
                    class="conflict-icon week-conflict"
                    title="Conflict detected in this week"
                  />
                </div>
              </div>
            </div>
            <div class="calendar-content">
              <div class="calendar-header">
                <div
                  v-for="day in [
                    $t('global.mondayshort'),
                    $t('global.tuesdayshort'),
                    $t('global.wednesdayshort'),
                    $t('global.thursdayshort'),
                    $t('global.fridayshort'),
                    $t('global.saturdayshort'),
                    $t('global.sundayshort'),
                  ]"
                  :key="day"
                  class="calendar-header-cell"
                >
                  {{ day }}
                </div>
              </div>

              <div class="calendar-grid">
                <div
                  class="calendar-row"
                  :style="{ height: `${100 / getNumberOfWeeks()}%` }"
                >
                  <div
                    v-for="date in getPreviousMonthDays()"
                    :key="'prev-' + date"
                    :style="{ height: `${cellHeight}px` }"
                    class="calendar-cell adjacent-month"
                  >
                    <div class="date-number">{{ date }}</div>
                    <div class="cell-content"></div>
                  </div>

                  <template>
                    <div
                      v-for="(day, index) in getDaysInMonth()"
                      class="calendar-cell current-month"
                      :class="{
                        'is-today': isToday(day),
                        'is-past': isPast(day),
                      }"
                      :key="'day-' + index"
                      :style="{ height: `${cellHeight}px` }"
                      @click.self="openDay(day)"
                    >
                      <div class="date-number">{{ day }}</div>
                      <div class="cell-content">
                        <div class="calendar-entries scrollable-entries">
                          <month-calendar-entry
                            v-for="entry in getCellEntries(day)"
                            :key="entry.id"
                            :day-conflicts="getConflicts(day)"
                            :termin-entry-d-t-o="entry"
                            @show-popup="
                              (payload) =>
                                showPopup({
                                  ...payload,
                                  colIndex:
                                    (index + getFirstDayOffset()) %
                                    calendarColumnCount,
                                })
                            "
                            @hide-popup="hidePopup"
                            @close-popup="hidePopup"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <div
                    v-for="date in getNextMonthDays()"
                    :key="'next-' + date"
                    :style="{ height: `${cellHeight}px` }"
                    class="calendar-cell adjacent-month"
                  >
                    <div class="date-number">{{ date }}</div>
                    <div class="cell-content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="hoveredEntry"
        class="calendar-popup"
        :style="popupStyle"
        @mouseenter="cancelHidePopup"
        @mouseleave="hidePopup"
      >
        <div
          v-if="hoveredEntry.veranstaltung"
          class="entry-event"
        >
          {{ hoveredEntry.veranstaltung.bezeichnung }}
        </div>
        <div class="entry-title">
          {{ hoveredEntry.bezeichnung || '-' }}
        </div>
        <div class="entry-info-row">
          <font-awesome-icon
            icon="fa-solid fa-clock"
            class="entry-icon"
          />
          {{ hoveredEntry.von_uhrzeit }} - {{ hoveredEntry.bis_uhrzeit }}
        </div>
        <template
          v-if="hoveredEntry.dozenten && hoveredEntry.dozenten.length > 0"
        >
          <div
            v-for="dozent in hoveredEntry.dozenten"
            :key="dozent.id || dozent.person_name"
            class="entry-info-row"
          >
            <font-awesome-icon
              :icon="['fad', 'chalkboard-teacher']"
              class="entry-icon"
            />
            {{ dozent.person_name }}
          </div>
        </template>
        <template
          v-if="hoveredEntry.raumliste && hoveredEntry.raumliste.length > 0"
        >
          <div
            v-for="raum in hoveredEntry.raumliste"
            :key="raum.id || raum.bezeichnung"
            class="entry-info-row"
          >
            <font-awesome-icon
              :icon="['fad', 'building']"
              class="entry-icon"
            />
            {{ raum.bezeichnung }}
          </div>
        </template>
        <div
          v-if="hoveredConflicts.length > 0"
          class="entry-conflicts"
        >
          <div class="conflicts-title">{{ $t('global.conflicts') }}:</div>
          <div
            v-for="(conflict, index) in hoveredConflicts"
            :key="index"
            class="conflict-item"
          >
            <span class="conflict-type">{{ conflict.type }}:</span>
            <span class="conflict-name">{{ conflict.designation }}</span>
            <span class="info-icon">
              <fa-icon
                :icon="['fas', 'fa-info-circle']"
                :title="$t('global.appointment') + ': ' + conflict.tooltip"
              />
            </span>
          </div>
        </div>
        <div class="entry-actions">
          <!-- Used to open edit appointment modal. Used, when backend fully changed to new put implementation. -->
          <font-awesome-icon
            :icon="['fad', 'pencil-alt']"
            class="action-icon"
            @click.stop="openEditAppointmentModal(hoveredEntry)"
            v-tooltip.hover.text="$t('global.edit')"
          />
          <font-awesome-icon
            :icon="['fas', 'up-right-from-square']"
            class="action-icon"
            @click.stop="openTermin(hoveredEntry)"
            v-tooltip.hover.text="$t('global.toAppointment')"
          />
        </div>
      </div>
    </div>
    <visual-planner-modal></visual-planner-modal>
    <neuer-termin-modal
      :id="'new-appointment-modal'"
      :planungsstati="planungsstati"
      :singleSelectVeranstaltungId="
        'new-appointment-modal' + 'single-select-veranstaltung-'
      "
      :durchfuehrungsstati="durchfuehrungsstati"
      :von="currentDateRangeForModal.von"
      :bis="currentDateRangeForModal.bis"
      :call_getTermine_method="false"
      :reload_page_data_after_saving="true"
      :canEditAppointment="true"
      :canOpenAppointment="true"
    ></neuer-termin-modal>
    <neuer-termin-modal
      :id="'edit-appointment-modal'"
      :planungsstati="planungsstati"
      :singleSelectVeranstaltungId="
        'edit-appointment-modal' + 'single-select-veranstaltung-'
      "
      :durchfuehrungsstati="durchfuehrungsstati"
      :von="currentDateRangeForModal.von"
      :bis="currentDateRangeForModal.bis"
      :call_getTermine_method="false"
      :reload_page_data_after_saving="true"
      :alternatingModalTitle="'global.editAppointmentDetails'"
      :canEditAppointment="true"
      :canOpenAppointment="true"
    ></neuer-termin-modal>
    <loading-overlay v-show="isLoading"></loading-overlay>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { FontAwesomeIcon as FaIcon } from '@fortawesome/vue-fontawesome'
  import DayColumn from '@/features/visual_planner/components/DayColumn.vue'
  import VisualPlannerModal from '@/features/visual_planner/components/VisualPlannerModal.vue'
  import NeuerTerminModal from '@/components/Modals/NeuerTerminModal'
  import dateUtils from '@/features/visual_planner/mixins/DateUtils'
  import { LADE_AUSWAHLWERTE_RESSOURCEN } from '@/store/ressourcen/actions.type'
  import Navbar from '@/components/Navbar.vue'
  import LoadingOverlay from '@/components/global/LoadingOverlay.vue'
  import MonthCalendarEntry from '@/features/visual_planner/components/CalendarEntryMonth.vue'
  import { LADE_AUSWAHLWERTE_DOZENT } from '@/store/dozent/actions.type'

  export default {
    name: 'VisualPlannerOverview',

    components: {
      MonthCalendarEntry,
      LoadingOverlay,
      Navbar,
      FaIcon,
      DayColumn,
      VisualPlannerModal,
      NeuerTerminModal,
    },

    mixins: [dateUtils],

    data() {
      return {
        actualDate: new Date(),
        timeZone: 'Europe/Zurich',

        timeIntervalOptions: [
          { value: 5, label: '5' },
          { value: 15, label: '15' },
          { value: 30, label: '30' },
          { value: 60, label: '60' },
        ],
        dayIntervalLocal: 7,
        timeIntervalLocal: 30,
        view: 'Day',
        windowHeight: window.innerHeight,
        tempRoomSelection: [],
        tempPersonSelection: [],
        tempSubjectSelection: [],
        tempCourseSelection: [],
        tempShortEventSelection: [],
        tempEducationalCourseSelection: [],
        selectedRooms: [],
        selectedPersons: [],
        selectedSubjects: [],
        selectedCourses: [],
        selectedShortEvents: [],
        selectedEducationalCourses: [],
        hoveredEntry: null,
        popupRect: null,
        hoveredConflicts: [],
        hidePopupTimeout: null,
        showFilters: false,
        filters: {
          roomIds: [],
          personIds: [],
          subjectIds: [],
        },
        popupAlign: 'right',
        now: new Date(),
        nowTimer: null,
        showSaturday: true,
        showSunday: false,
        showDatePicker: false,
      }
    },

    computed: {
      dayIntervalOptions() {
        return [
          { value: 1, label: this.$t('global.day') },
          { value: 7, label: this.$t('global.week') },
          { value: 31, label: this.$t('global.month') },
        ]
      },
      durchfuehrungsstati: {
        get() {
          return this.$store.state.dozent.durchfuehrungsstati
        },
      },

      planungsstati: {
        get() {
          return this.$store.state.dozent.planungsstati
        },
      },

      calendarColumnCount() {
        if (this.dayIntervalLocal === 1) return 1
        if (this.dayIntervalLocal >= 7) return 7
        return this.dayIntervalLocal
      },
      popupStyle() {
        if (!this.popupRect) return {}

        const cellMiddle =
          this.popupRect.top + this.popupRect.height / 2 + window.scrollY
        if (this.popupAlign === 'left') {
          return {
            position: 'absolute',
            right: `${window.innerWidth - this.popupRect.left + 10}px`,
            top: `${cellMiddle}px`,
            transform: 'translateY(-50%)',
            zIndex: 2000,
            minWidth: '220px',
          }
        } else {
          return {
            position: 'absolute',
            left: `${this.popupRect.right + 10 + window.scrollX}px`,
            top: `${cellMiddle}px`,
            transform: 'translateY(-50%)',
            zIndex: 2000,
            minWidth: '220px',
          }
        }
      },
      ...mapState('VisualPlannerMetadata', {
        calcTimeModulo: (state) => state.timeModulo,
        dayInterval: (state) => state.dayInterval,
        timeInterval: (state) => state.timeInterval,
      }),
      ...mapState('VisualPlannerData', {
        isLoading: (state) => state.isLoading,
        requestStartDate: (state) => state.requestStartDate,
        requestEndDate: (state) => state.requestEndDate,
      }),
      ...mapGetters('VisualPlannerMetadata', ['calcRowCountFromTimeInterval']),
      ...mapState('VisualPlannerSelectionValue', {
        selectionValueIsLoading: (state) => state.isLoading,
      }),
      ...mapState('VisualPlannerData', ['dayList']),

      monthPickerValue() {
        const y = this.actualDate.getFullYear()
        const m = String(this.actualDate.getMonth() + 1).padStart(2, '0')
        return `${y}-${m}`
      },
      datePickerValue() {
        const y = this.actualDate.getFullYear()
        const m = String(this.actualDate.getMonth() + 1).padStart(2, '0')
        const d = String(this.actualDate.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      },
      currentDateRange() {
        if (this.view === 'Month') {
          return new Intl.DateTimeFormat('en-US', {
            month: 'long',
            year: 'numeric',
          }).format(this.actualDate)
        }

        const adjustedDate = this.adjustDate(this.actualDate)
        const { startOfWeek, endOfWeek } =
          this.calculateWeekBoundaries(adjustedDate)
        return this.formatDateRange(startOfWeek, endOfWeek)
      },
      currentDateRangeForModal() {
        let von, bis
        if (this.view === 'Month') {
          von = new Date(
            this.actualDate.getFullYear(),
            this.actualDate.getMonth(),
            1
          )
          bis = new Date(
            this.actualDate.getFullYear(),
            this.actualDate.getMonth() + 1,
            0
          )
        } else if (this.dayIntervalLocal === 7) {
          // Week view
          const adjustedDate = this.adjustDate(this.actualDate)
          const { startOfWeek, endOfWeek } =
            this.calculateWeekBoundaries(adjustedDate)
          von = startOfWeek
          bis = endOfWeek
        } else {
          // Day view
          von = this.actualDate
          bis = this.actualDate
        }
        // Format as "dd.mm.yyyy"
        return {
          von: new Intl.DateTimeFormat('de-CH').format(von),
          bis: new Intl.DateTimeFormat('de-CH').format(bis),
        }
      },
      raeume: {
        get() {
          return this.$store.state.ressourcen.raeume
        },
      },
      persons: {
        get() {
          return this.$store.state.VisualPlannerSelectionValue.persons
        },
      },
      subjects: {
        get() {
          return this.$store.state.VisualPlannerSelectionValue.subjects
        },
      },
      courses: {
        get() {
          return this.$store.state.VisualPlannerSelectionValue.courses
        },
      },
      shortevents: {
        get() {
          return this.$store.state.VisualPlannerSelectionValue.shortevents
        },
      },
      educationalCourses: {
        get() {
          return this.$store.state.VisualPlannerSelectionValue
            .educationalCourses
        },
      },
      headerHeight() {
        return 174
      },
      cellHeight() {
        const availableHeight = this.windowHeight - this.headerHeight + 27
        return availableHeight / this.getNumberOfWeeks()
      },
      sortedDayList() {
        return this.dayList.map((day) => ({
          ...day,
          time_block_list: [...day.time_block_list].sort((a, b) => {
            if (a.von !== b.von) {
              return a.von.localeCompare(b.von)
            }
            return a.von_uhrzeit.localeCompare(b.von_uhrzeit)
          }),
        }))
      },
      showNowLine() {
        if (this.view === 'Month') return false
        if (!this.requestStartDate || !this.requestEndDate) return false
        const start = new Date(this.requestStartDate)
        const end = new Date(this.requestEndDate)
        const today = new Date()
        start.setHours(0, 0, 0, 0)
        end.setHours(23, 59, 59, 999)
        today.setHours(0, 0, 0, 0)
        return today >= start && today <= end
      },
      nowTopPercent() {
        const n = this.now
        const minutes = n.getHours() * 60 + n.getMinutes()
        return (minutes / 1440) * 100
      },
      nowLeftPercent() {
        const idx = this.todayVisibleIndex
        if (idx === null) return 0
        return (100 / this.layoutDayInterval) * idx
      },
      todayIndexInRange() {
        if (!this.showNowLine) return null
        const start = new Date(this.requestStartDate)
        const today = new Date()
        start.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        const diffDays = Math.floor((today - start) / (1000 * 60 * 60 * 24))
        if (diffDays < 0 || diffDays >= this.dayIntervalLocal) return null
        return diffDays
      },

      applyWeekendFilter() {
        // Wir filtern nur in der Wochenansicht (>=2 Tage)
        return this.dayIntervalLocal > 1
      },
      visibleIndices() {
        // Liefert die Indexliste (0..dayIntervalLocal-1) ohne ausgeblendete Tage
        if (!this.applyWeekendFilter) {
          return Array.from({ length: this.dayIntervalLocal }, (_, i) => i)
        }
        const arr = []
        for (let i = 0; i < this.dayIntervalLocal; i++) {
          const d = this.getDateByIndexAndStartDate(i, this.requestStartDate)
          const dow = d.getDay() // 0=So, 6=Sa
          if (!this.showSunday && dow === 0) continue
          if (!this.showSaturday && dow === 6) continue
          arr.push(i)
        }
        return arr
      },
      layoutDayInterval() {
        // Anzahl tatsächlich sichtbarer Spalten (für Breite/Position)
        return this.visibleIndices.length || this.dayIntervalLocal
      },
      todayVisibleIndex() {
        if (!this.applyWeekendFilter) return this.todayIndexInRange
        // finde "Heute" innerhalb der sichtbaren Indizes
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        for (let pos = 0; pos < this.visibleIndices.length; pos++) {
          const i = this.visibleIndices[pos]
          const d = this.getDateByIndexAndStartDate(i, this.requestStartDate)
          const dd = new Date(d)
          dd.setHours(0, 0, 0, 0)
          if (dd.getTime() === today.getTime()) return pos
        }
        return null
      },
    },

    watch: {
      selectedRooms: {
        handler(newVal) {
          this.filters.roomIds = newVal
          this.setRoomIds(newVal)
          this.fetchDayList(this.dayIntervalLocal)
        },
        deep: true,
      },
      selectedPersons: {
        handler(newVal) {
          this.filters.personIds = newVal
          this.setPersonIds(newVal)
          this.fetchDayList(this.dayIntervalLocal)
        },
        deep: true,
      },
      selectedSubjects: {
        handler() {
          this.updateEventIds()
        },
        deep: true,
      },
      selectedCourses: {
        handler() {
          this.updateEventIds()
        },
        deep: true,
      },
      selectedShortEvents: {
        handler() {
          this.updateEventIds()
        },
        deep: true,
      },
      selectedEducationalCourses: {
        handler() {
          this.updateEventIds()
        },
        deep: true,
      },

      tempRoomSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedRooms = Array.from(
            new Set([...this.selectedRooms, ...newVal])
          )
          this.tempRoomSelection = []
        }
      },
      tempPersonSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedPersons = Array.from(
            new Set([...this.selectedPersons, ...newVal])
          )
          this.tempPersonSelection = []
        }
      },
      tempSubjectSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedSubjects = Array.from(
            new Set([...this.selectedSubjects, ...newVal])
          )
          this.tempSubjectSelection = []
        }
      },
      tempCourseSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedCourses = Array.from(
            new Set([...this.selectedCourses, ...newVal])
          )
          this.tempCourseSelection = []
        }
      },
      tempShortEventSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedShortEvents = Array.from(
            new Set([...this.selectedShortEvents, ...newVal])
          )
          this.tempShortEventSelection = []
        }
      },
      tempEducationalCourseSelection(newVal) {
        if (newVal && newVal.length) {
          this.selectedEducationalCourses = Array.from(
            new Set([...this.selectedEducationalCourses, ...newVal])
          )
          this.tempEducationalCourseSelection = []
        }
      },
      actualDate: {
        handler(newDate) {
          const adjustedDate = this.adjustDate(newDate)
          const { startOfWeek, endOfWeek } =
            this.calculateWeekBoundaries(adjustedDate)
          this.setRequestStartDate(startOfWeek)
          this.setRequestEndDate(endOfWeek)
          this.fetchDayList(this.dayIntervalLocal)
        },
        immediate: true,
      },
      dayIntervalLocal: {
        handler(newVal) {
          this.view = newVal > 7 ? 'Month' : 'Day'

          if (newVal === 7) {
            const date = new Date(this.actualDate)
            const diff =
              date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
            this.actualDate = new Date(date.setDate(diff))
          }

          if (newVal > 7) {
            const date = new Date(this.actualDate)
            this.actualDate = new Date(date.getFullYear(), date.getMonth(), 1)
          }

          this.setDayInterval(newVal)
          this.$nextTick(() => this.scrollToHour(8))
        },
        immediate: true,
      },
      timeIntervalLocal(newVal) {
        this.setTimeInterval(newVal)
      },
      timeInterval() {
        this.$nextTick(() => this.scrollToHour(8))
      },
    },

    methods: {
      ...mapActions('FeatureMetadata', ['openTimeBlockEditModal']),
      ...mapActions('VisualPlannerMetadata', ['setActiveTerminEntry']),

      updateEventIds() {
        const all = [
          ...this.selectedSubjects,
          ...this.selectedCourses,
          ...this.selectedShortEvents,
          ...this.selectedEducationalCourses,
        ]
        const unique = Array.from(new Set(all))
        this.filters.eventIds = unique // optional, falls du die lokale Anzeige brauchst
        this.setEventIds(unique) // -> Store
        this.fetchDayList(this.dayIntervalLocal)
      },
      openDatePicker() {
        this.showDatePicker = true
        this.$nextTick(() => {
          if (this.$refs.datePicker) {
            this.$refs.datePicker.focus()
            this.$refs.datePicker.showPicker?.()
          }
        })
      },

      jumpToDate(value) {
        if (!value) return
        if (this.view === 'Month') {
          const [year, month] = value.split('-').map(Number)
          this.actualDate = new Date(year, month - 1, 1)
        } else {
          const [year, month, day] = value.split('-').map(Number)
          this.actualDate = new Date(year, month - 1, day)
        }
        this.showDatePicker = false
      },

      openNewAppointmentModal() {
        this.$bus.$emit('openNeuerTerminModal:new', `new-appointment-modal`)
      },
      openEditAppointmentModal(appointment) {
        this.$bus.$emit(
          'openNeuerTerminModal:edit',
          `edit-appointment-modal`,
          appointment
        )
        this.hidePopup()
      },
      reloadPageData() {
        this.fetchDayList(this.dayIntervalLocal)
      },
      openTermin(entry = this.hoveredEntry) {
        if (!entry) return
        const routeData = this.$router.resolve({
          name: 'termin',
          params: { id: entry.id, anzeige: 0 },
        })
        window.open(routeData.href, '_blank')
      },
      showPopup({ entry, conflicts, rect, colIndex }) {
        if (this.hidePopupTimeout) {
          clearTimeout(this.hidePopupTimeout)
          this.hidePopupTimeout = null
        }
        this.hoveredEntry = entry
        this.hoveredConflicts = conflicts
        this.popupRect = rect
        if (
          colIndex === this.calendarColumnCount - 1 ||
          colIndex === this.calendarColumnCount - 2
        ) {
          this.popupAlign = 'left'
        } else {
          this.popupAlign = 'right'
        }
      },
      hidePopup() {
        this.hidePopupTimeout = setTimeout(() => {
          this.hoveredEntry = null
          this.popupRect = null
          this.hoveredConflicts = []
        }, 250)
      },
      cancelHidePopup() {
        if (this.hidePopupTimeout) {
          clearTimeout(this.hidePopupTimeout)
          this.hidePopupTimeout = null
        }
      },
      removeRoom(id) {
        this.selectedRooms = this.selectedRooms.filter((rid) => rid !== id)
      },
      removePerson(id) {
        this.selectedPersons = this.selectedPersons.filter((pid) => pid !== id)
      },
      removeSubject(id) {
        this.selectedSubjects = this.selectedSubjects.filter(
          (sid) => sid !== id
        )
      },
      removeCourse(id) {
        this.selectedCourses = this.selectedCourses.filter((cid) => cid !== id)
      },
      removeShortEvent(id) {
        this.selectedShortEvents = this.selectedShortEvents.filter(
          (seid) => seid !== id
        )
      },
      removeEducationalCourse(id) {
        this.selectedEducationalCourses =
          this.selectedEducationalCourses.filter((ecid) => ecid !== id)
      },
      openDayFromWeek(date) {
        this.dayIntervalLocal = 1
        this.actualDate = new Date(date)
      },

      setPeopleConflictsFilter(date) {
        const formattedDate = this.formatDate(date)
        const dayData = this.getDayDataWithSqlDate(formattedDate)
        if (dayData?.conflicts?.length) {
          this.filters.personIds = [
            ...new Set(
              dayData.conflicts.flatMap(
                (conflict) =>
                  conflict.people_conflicts?.map(
                    (person) => person.conflicting_resource_id
                  ) || []
              )
            ),
          ]
        }
      },

      setRoomConflictsFilter(date) {
        const formattedDate = this.formatDate(date)
        const dayData = this.getDayDataWithSqlDate(formattedDate)
        if (dayData?.conflicts?.length) {
          // Changed condition here
          this.filters.roomIds = [
            ...new Set(
              dayData.conflicts.flatMap(
                (conflict) =>
                  conflict.room_conflicts?.map(
                    (room) => room.conflicting_resource_id
                  ) || []
              )
            ),
          ]
        }
      },

      openDay(day) {
        const targetDate = new Date(
          this.actualDate.getFullYear(),
          this.actualDate.getMonth(),
          day
        )

        this.dayIntervalLocal = 1

        this.actualDate = targetDate
      },

      openWeek(weekNum) {
        const currentDate = new Date(this.actualDate)
        const year = currentDate.getFullYear()

        const targetDate = new Date(year, 0, 1 + (weekNum - 1) * 7)
        const dayOfWeek = targetDate.getDay() || 7
        targetDate.setDate(targetDate.getDate() - dayOfWeek + 1)

        if (currentDate.getMonth() === 11 && weekNum === 1) {
          targetDate.setFullYear(year + 1)
        }

        this.dayIntervalLocal = 7
        this.actualDate = targetDate
      },

      handleResize() {
        this.windowHeight = window.innerHeight
      },

      getCellEntries(day) {
        const date = this.getDateForCell(day)
        const dateString = this.getSQLDateFromDate(date)
        const dayData = this.sortedDayList.find(
          (d) => d.day_metadata === dateString
        )
        return dayData && dayData.time_block_list ? dayData.time_block_list : []
      },

      getDayData(day) {
        const date = this.getDateForCell(day)
        const dateString = this.getSQLDateFromDate(date)
        return this.dayList.find((d) => d.day_metadata === dateString)
      },

      getDayDataWithSqlDate(sqlDate) {
        return this.dayList.find((d) => d.day_metadata === sqlDate)
      },

      getConflicts(day) {
        const dayData = this.getDayData(day)
        return dayData?.conflicts || []
      },

      hasRoomConflicts(day) {
        const dayData = this.getDayData(day)
        return dayData?.has_room_conflicts || false
      },

      hasPersonConflicts(day) {
        const dayData = this.getDayData(day)
        return dayData?.has_people_conflicts || false
      },

      hasPersonConflictsDate(d) {
        const date = d instanceof Date ? d : d ? new Date(d) : null
        if (!date || isNaN(date.getTime())) return false
        const formattedDate = this.formatDate(date)
        const dayData = this.getDayDataWithSqlDate(formattedDate)
        return dayData?.has_people_conflicts || false
      },

      hasRoomConflictsDate(date) {
        const formattedDate = this.formatDate(date)
        const dayData = this.getDayDataWithSqlDate(formattedDate)
        return dayData?.has_room_conflicts || false
      },

      formatDate(date) {
        const dt = date instanceof Date ? date : date ? new Date(date) : null
        if (!dt || isNaN(dt.getTime())) return ''
        const y = dt.getFullYear()
        const m = String(dt.getMonth() + 1).padStart(2, '0')
        const d = String(dt.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      },

      ...mapActions('VisualPlannerData', [
        'setRequestStartDate',
        'setRequestEndDate',
        'setRoomIds',
        'setPersonIds',
        'setEventIds',
        'fetchDayList',
      ]),
      ...mapActions('VisualPlannerMetadata', [
        'setDayInterval',
        'setTimeInterval',
      ]),
      ...mapActions('VisualPlannerSelectionValue', ['fetchSelectionValues']),

      adjustDate(date) {
        const adjustedDate = new Date(date)
        adjustedDate.setMinutes(
          adjustedDate.getMinutes() + adjustedDate.getTimezoneOffset()
        )
        adjustedDate.setHours(adjustedDate.getHours() + 2)
        return adjustedDate
      },

      calculateWeekBoundaries(date) {
        const startOfWeek = new Date(date)

        if (this.dayIntervalLocal === 7) {
          const diff =
            date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
          startOfWeek.setDate(diff)
        }

        const endOfWeek = new Date(startOfWeek)
        endOfWeek.setDate(startOfWeek.getDate() + (this.dayIntervalLocal - 1))

        return { startOfWeek, endOfWeek }
      },

      formatDateRange(startDate, endDate) {
        const dateFormatOptions = {
          month: 'short',
          day: 'numeric',
          timeZone: this.timeZone,
        }

        const yearFormatOptions = {
          year: 'numeric',
          timeZone: this.timeZone,
        }

        const startDateString = startDate.toLocaleDateString(
          'en-US',
          dateFormatOptions
        )
        const endDateString = endDate.toLocaleDateString(
          'en-US',
          dateFormatOptions
        )
        const yearString = endDate.toLocaleDateString(
          'en-US',
          yearFormatOptions
        )
        const weekNumber = this.getWeek(endDate)

        return `${startDateString} - ${endDateString}, ${yearString} (Week ${weekNumber})`
      },

      /*addTimeBlock() {
      this.openTimeBlockModal()
    },*/

      handleClick(event) {
        const container = document.getElementById('visual-planner-container')
        if (!container) return

        const rect = container.getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top

        const columnWidth = container.clientWidth / this.dayIntervalLocal
        const columnIndex = Math.floor(x / columnWidth)

        const scrollOffset = container.scrollTop
        const pixelHeight = y + scrollOffset

        const rowHeight = 24
        const rowIndex = Math.floor(pixelHeight / rowHeight)

        const containerHeight = container.scrollHeight
        const percentageOffset = (pixelHeight / containerHeight) * 100

        console.log('Column Index:', columnIndex)
        console.log('Row Index:', rowIndex)
        console.log('Pixel Height:', pixelHeight)
        console.log(
          'Percentage Offset from Top:',
          percentageOffset.toFixed(2) + '%'
        )
      },

      getWeek(date) {
        const firstDayOfYear = new Date(date.getFullYear(), 0, 1)
        const pastDaysOfYear =
          (date.getTime() - firstDayOfYear.getTime()) / 86400000
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
      },

      incrementDateRange() {
        if (this.view === 'Month') {
          const newDate = new Date(this.actualDate)
          newDate.setMonth(newDate.getMonth() + 1)
          this.actualDate = newDate
        } else {
          this.actualDate = new Date(
            this.actualDate.getTime() +
              this.dayIntervalLocal * 24 * 60 * 60 * 1000
          )
        }
      },

      decrementDateRange() {
        if (this.view === 'Month') {
          const newDate = new Date(this.actualDate)
          newDate.setMonth(newDate.getMonth() - 1)
          this.actualDate = newDate
        } else {
          this.actualDate = new Date(
            this.actualDate.getTime() -
              this.dayIntervalLocal * 24 * 60 * 60 * 1000
          )
        }
      },

      getDaysInMonth(monthOffset = 0) {
        const date = new Date(this.actualDate)
        return new Date(
          date.getFullYear(),
          date.getMonth() + monthOffset + 1,
          0
        ).getDate()
      },

      getFirstDayOffset() {
        const date = new Date(this.actualDate)
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        let dayOfWeek = firstDay.getDay() || 7
        return dayOfWeek - 1
      },
      getPreviousMonthDays() {
        const offset = this.getFirstDayOffset()
        if (offset === 0) return []

        const prevMonthDays = this.getDaysInMonth(-1)
        return Array.from(
          { length: offset },
          (_, i) => prevMonthDays - offset + i + 1
        )
      },
      getNextMonthDays() {
        const daysInMonth = this.getDaysInMonth()
        const offset = this.getFirstDayOffset()
        const totalDays = daysInMonth + offset
        const nextDays = Math.ceil(totalDays / 7) * 7 - totalDays

        if (totalDays % 7 === 0) return []

        return Array.from({ length: nextDays }, (_, i) => i + 1)
      },

      getDateForCell(dayNumber) {
        return new Date(
          this.actualDate.getFullYear(),
          this.actualDate.getMonth(),
          dayNumber
        )
      },
      getNumberOfWeeks() {
        const daysInMonth = this.getDaysInMonth()
        const firstDayOffset = this.getFirstDayOffset()
        const totalDays = daysInMonth + firstDayOffset
        return Math.ceil(totalDays / 7)
      },
      getWeekNumbers() {
        const date = new Date(this.actualDate)
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        const weeks = []

        let currentDate = new Date(firstDay)
        let currentWeek = this.getWeekNumber(currentDate)

        for (let i = 0; i < this.getNumberOfWeeks(); i++) {
          weeks.push(currentWeek)
          currentWeek = currentWeek + 1
          if (currentWeek > 52) currentWeek = 1
        }

        return weeks
      },

      getWeekNumber(date) {
        const d = new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        )
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
        return Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
      },
      hasWeekConflicts(weekNum) {
        // Montag der sichtbaren Woche suchen (aus dem Monatsraster)
        const weekStart = this.getWeekStartDateByNumber(weekNum)
        if (!weekStart) return false

        // 7 Tage prüfen – mit den *Date*-Varianten
        for (let i = 0; i < 7; i++) {
          const d = new Date(weekStart)
          d.setDate(weekStart.getDate() + i)
          if (this.hasRoomConflictsDate(d) || this.hasPersonConflictsDate(d)) {
            return true
          }
        }
        return false
      },

      getWeekStartDateByNumber(weekNum) {
        // Start des Monatsrasters (Montag der ersten sichtbaren Woche)
        const year = this.actualDate.getFullYear()
        const month = this.actualDate.getMonth()
        const firstOfMonth = new Date(year, month, 1)
        const dow = firstOfMonth.getDay() || 7 // So=0 -> 7
        const gridStart = new Date(firstOfMonth)
        if (dow > 1) gridStart.setDate(firstOfMonth.getDate() - (dow - 1))

        // Max. 6 Rasterwochen durchsuchen, bis die gesuchte ISO-Woche gefunden ist
        for (let i = 0; i < 7; i++) {
          const monday = new Date(gridStart)
          monday.setDate(gridStart.getDate() + i * 7)
          if (this.getWeekNumber(monday) === weekNum) {
            return monday // Montag dieser sichtbaren Woche
          }
        }
        return null // sollte in der Praxis nicht passieren
      },

      isToday(day) {
        const d =
          this.getDateForCell(day) ||
          new Date(
            this.actualDate.getFullYear(),
            this.actualDate.getMonth(),
            day
          )
        const today = new Date()
        d.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        return d.getTime() === today.getTime()
      },
      isPast(day) {
        const d =
          this.getDateForCell(day) ||
          new Date(
            this.actualDate.getFullYear(),
            this.actualDate.getMonth(),
            day
          )
        const today = new Date()
        d.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        return d.getTime() < today.getTime()
      },
      isPastDate(d) {
        const x = new Date(d),
          today = new Date()
        x.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        return x.getTime() < today.getTime()
      },
      isTodayDate(d) {
        const x = new Date(d),
          today = new Date()
        x.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        return x.getTime() === today.getTime()
      },

      scrollToHour(targetHour = 8) {
        if (this.view === 'Month') return // Nur Day/Week
        const el = this.$refs.overviewSection
        if (!el) return

        const interval = this.timeInterval || 30 // Minuten pro Raster
        const rowsUntilHour = Math.floor((targetHour * 60) / interval)
        const ROW_HEIGHT = 24 // px je Rasterzeile (wie im Grid)
        const offsetPx = rowsUntilHour * ROW_HEIGHT

        // Direkt setzen – keine sanfte Animation, damit 08:00 „oben“ klebt
        el.scrollTop = offsetPx
      },

      safeDayName(d) {
        const dt = d instanceof Date ? d : d ? new Date(d) : null
        if (!dt || isNaN(dt.getTime())) return ''
        // nutzt dein DateUtils-Mixin
        return this.getDayName(dt)
      },
      safeDayNumber(d) {
        const dt = d instanceof Date ? d : d ? new Date(d) : null
        return !dt || isNaN(dt.getTime()) ? '' : dt.getDate()
      },
      showToday() {
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        // Monatsansicht (bei dir: dayIntervalLocal > 7, z.B. 31)
        if (this.dayIntervalLocal > 7) {
          this.actualDate = new Date(today.getFullYear(), today.getMonth(), 1)
          return
        }

        // Wochenansicht (bei dir: dayIntervalLocal === 7) -> Montag der aktuellen Woche
        if (this.dayIntervalLocal === 7) {
          const monday = new Date(today)
          const dow = monday.getDay() || 7 // So=0 -> 7
          monday.setDate(monday.getDate() - dow + 1)
          this.actualDate = monday
          this.$nextTick(() => this.scrollToHour(8))
          return
        }

        // Tagesansicht (bei dir: dayIntervalLocal === 1)
        this.actualDate = today
        this.$nextTick(() => this.scrollToHour(8))
      },
    },

    mounted() {
      this.dayIntervalLocal = this.dayInterval
      this.timeIntervalLocal = this.timeInterval
      window.addEventListener('resize', this.handleResize)
      if (
        this.durchfuehrungsstati.length == 0 ||
        this.planungsstati.length == 0
      )
        this.$store.dispatch(`dozent/${LADE_AUSWAHLWERTE_DOZENT}`)

      this.nowTimer = setInterval(() => {
        this.now = new Date()
      }, 60 * 1000)

      this.$nextTick(() => this.scrollToHour(8))
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
      if (this.nowTimer) clearInterval(this.nowTimer)
    },

    created() {
      //TODO() Tight coupling to education APP needs to be added to the feature once extracting
      if (this.raeume.length == 0)
        this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`)

      if (this.persons.length == 0) this.fetchSelectionValues()
    },
  }
</script>

<style lang="scss" scoped>
  :root {
    --vp-toolbar-h: 48px;
  }
  @import '@/features/visual_planner/scss/color';

  #overview-container {
    background-color: $color-bg-primary;
    display: flex;
    flex-direction: column;
  }

  #overview-container.full-height {
    height: calc(100vh - 62px);
  }

  #education-wrapper {
    height: calc(100vh - 62px);
    background-color: $color-bg-primary;
  }

  #action-bar-head-container {
    padding: 10px 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-top: 1px solid $color-border-primary;
    border-left: 1px solid $color-border-primary;
    border-right: 1px solid $color-border-primary;
    background-color: $color-bg-secondary;
    position: sticky;
    top: 70px; // klebt unter der App-Navigation
    z-index: 30;
    min-height: var(--vp-toolbar-h);
  }

  .overview-outer-wrapper {
    margin-top: 70px;
    // margin: 4.7rem 0.5rem 1rem 0.5rem;
    // border: 12px solid $color-bg-tertiary;
    // border-radius: 15px;
  }

  .action-bar {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
  }

  .action-bar .content-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 70%;
  }

  .action-bar .content-right {
    display: flex;
    gap: 8px;
    flex: 1;
    width: 30%;
  }

  .action-bar .content-left button,
  .action-bar .content-left input,
  .action-bar .content-left select {
    height: 30px;
    font-size: 0.875rem;
    justify-content: space-between;
  }

  .action-bar .content-left button {
    min-width: 120px;
  }

  .action-bar .content-right {
    justify-content: center;
    cursor: default;
  }

  .action-bar .content-right div {
    width: 224px;
    display: flex;
    justify-content: center;
  }

  select.primary-btn {
    width: 120px;
  }

  .select-wrap {
    min-width: 100px;
    position: relative;
  }

  .date-range {
    font-weight: bold;
    font-size: 1rem;
    color: $color-text-primary;
    cursor: default;

    .date-range-label {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .date-picker-input {
      font-weight: bold;
      font-size: 0.9rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 2px 6px;
      outline: none;
      color: $color-text-primary;
      background: white;
    }
  }

  .multi-select-wrap {
    min-width: 150px;
    max-width: 200px;
    position: relative;
  }

  .select-label {
    color: $color-text-caution;
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .action-bar div {
    font-size: 0.875rem;
    align-self: center;
  }

  .visual-planner-head-container {
    position: sticky;
    top: 122px; // sitzt direkt unter der Toolbar
    z-index: 20;
    border: 1px solid $color-border-primary;
    background: $color-bg-secondary;
  }

  .header-empty-cell {
    width: 48px;
    min-width: 48px;
    max-width: 48px;
    background-color: $color-bg-secondary;
  }

  .visual-planner-header {
    display: flex;
    justify-content: space-between;
  }

  .visual-planner-header .interval-column-head {
    border-left: 1px solid $color-border-primary;
    background-color: $color-bg-secondary;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    min-height: 48px;
    cursor: pointer;

    &:hover {
      background-color: rgb($color-bg-tertiary, 0.5);
    }
  }

  .visual-planner-header .day {
    display: flex;
    flex-direction: column;
    color: $color-text-primary;
    min-width: 45px;
  }

  .visual-planner-header .day-text {
    font-size: 0.875rem;
    font-weight: bold;
    color: $color-text-primary;
    cursor: default;
  }

  .visual-planner-header .day-number {
    font-size: 1.125rem;
    font-weight: bold;
    cursor: default;
  }

  .visual-planner-header .icons {
    height: 100%;
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .visual-planner-header .icon {
    color: $color-accent;
    font-size: 1.125rem;
    cursor: pointer;
  }

  #overview {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .visual-planner-body {
    display: flex;
    background-color: $color-bg-tertiary;
  }

  #visual-planner-side-bar {
    width: 50px;
    display: flex;
    flex-direction: column;
    background-color: $color-bg-secondary;
    z-index: 10;
  }

  #visual-planner-side-bar .background-row {
    border-right: unset;
  }

  .sidebar-hour {
    text-align: center;
    padding-top: 3px;
    color: $color-text-primary;
    font-size: 0.875rem;
  }

  #visual-planner-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $color-bg-tertiary;
  }

  .background-row {
    height: 24px;
    border-bottom: 1px solid $color-border-primary;
    border-right: 1px solid $color-border-primary;
  }

  .background-row :hover {
    background-color: rgb($color-bg-tertiary, 0.5);
  }

  .background-row-dashed {
    border-bottom: 1px dashed $color-border-primary;
  }

  @media (max-width: 1200px) {
    .action-bar .content-left {
      justify-content: center;
    }

    .action-bar {
      justify-content: center;
    }

    .action-bar .content-right {
      justify-content: center;
      margin-top: 8px;
    }

    .visual-planner-header .icons {
      display: none;
    }

    .visual-planner-header .interval-column-head {
      display: flex;
      align-content: center;
      justify-content: center;
    }

    .visual-planner-header .day {
      display: flex;
      flex-direction: row;
      column-gap: 8px;
      align-items: center;
    }

    .visual-planner-header .day-text {
      font-size: 0.75rem;
    }

    .visual-planner-header .day-number {
      font-size: 0.875rem;
    }
  }

  .month-view {
    width: 100%;
    height: 100vh;
    background: $color-bg-secondary;
  }

  .calendar-layout {
    display: flex;
    height: 100%;
  }

  .week-numbers {
    display: flex;
    flex-direction: column;
  }

  .week-header {
    height: 44px;
    position: sticky;
    top: var(--vp-toolbar-h);
    z-index: 20;
    background: $color-bg-secondary;
  }

  .week-column {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .week-cell {
    cursor: pointer;
    position: relative;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid $color-border-primary;

    &:first-child {
      border-top: 1px solid $color-border-primary;
    }

    &:last-child {
      border-bottom: 1px solid $color-border-primary;
    }

    &:hover {
      background-color: rgba($color-bg-tertiary, 0.5);
    }
  }

  .week-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    transform: rotate(-90deg);
  }

  .conflict-icon {
    position: absolute;
    top: 15px;
    color: $color-danger;
    rotate: -90deg;
    cursor: help;
  }

  .rotated-text {
    white-space: nowrap;
    font-size: 0.875rem;
    color: $color-text-secondary;
  }

  .calendar-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto; // Scroll hier
  }

  .calendar-header {
    border: 1px solid $color-border-primary;
    height: 44px;
    position: sticky;
    top: var(--vp-toolbar-h);
    z-index: 20;
    background: $color-bg-secondary;
  }

  .calendar-header-cell {
    padding: 12px;
    text-align: center;
    font-weight: bold;
    color: $color-text-primary;
    border-right: 1px solid $color-border-primary;

    &:last-child {
      border-right: none;
    }
  }

  .calendar-grid {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .calendar-row {
    border-bottom: 1px solid $color-border-primary;
  }

  .calendar-header,
  .calendar-row {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    box-sizing: border-box;
  }

  .calendar-cell {
    border: 1px solid $color-border-primary;
    border-bottom: none;
    padding: 8px;
    position: relative;
    overflow: visible;
    cursor: pointer;

    &.current-month {
      background-color: $color-bg-tertiary;
    }

    &.adjacent-month {
      background-color: $color-bg-quaternary;
      color: $color-text-secondary;

      .date-number {
        color: $color-text-secondary;
      }
    }

    &:hover {
      .month-entry {
        background-color: $color-bg-primary;
      }

      background-color: rgba($color-bg-tertiary, 0.5);
    }

    .conflict-indicators {
      position: absolute;
      top: 4px;
      left: 4px;
      display: flex;
      gap: 4px;
    }

    .conflict-icon {
      font-size: 0.75rem;
      opacity: 0.7;

      &.room-conflict {
        color: $color-danger;
      }

      &.person-conflict {
        color: $color-danger;
      }
    }
  }

  // Hervorhebung der Zahl von heute
  .calendar-cell.current-month.is-today .date-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border-radius: 9999px;
    background-color: $color-border-secondary;
    color: $color-white;
    font-weight: 700;
  }

  // Vergangene Tage leicht ausgegraut
  .calendar-cell.current-month.is-past {
    background-color: rgba(0, 0, 0, 0.03); // sehr subtil
  }
  .calendar-cell.current-month.is-past .date-number {
    opacity: 0.6;
  }

  /* Heute im Wochen/Tag-Header als Kreis markieren */
  .visual-planner-header .interval-column-head.is-today .day-number {
    display: inline-flex; /* damit Breite/Höhe wirken */
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: $color-border-secondary;
    color: $color-white; /* Zahl in Akzentfarbe */
    line-height: 1; /* saubere Zentrierung */
  }

  .date-number {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 0.875rem;
    color: $color-text-primary;
  }

  .scrollable-entries {
    max-height: 100%;
  }

  .cell-content {
    margin-top: 24px;
    height: calc(100% - 24px);
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .calendar-entries {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 3px;
    position: relative;
    z-index: 1;
  }

  .filter-summary-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    background-color: $color-bg-secondary;
    padding-bottom: 4px;
  }

  .filter-summary {
    margin-bottom: 0;
    margin-left: 5px;
  }

  .conflict-indicators {
    color: $color-danger;
    font-size: 1.3rem;

    &:hover {
      color: rgb($color-danger, 1.5);
    }
  }

  .filter-chip {
    display: inline-flex;
    align-items: center;
    border: 1px solid $color-text-primary;
    border-radius: 4px;
    padding: 2px 8px;
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 2px;
    font-size: 0.95em;
    box-shadow: 0px 1px 2px rgba(39, 58, 77, 0.25);

    &:hover {
      background-color: rgba($color-bg-tertiary, 0.5);
    }
  }

  .chip-remove {
    background: transparent;
    border: none;
    color: $color-danger;
    font-size: 1em;
    margin-left: 4px;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1;
  }

  .chip-remove:hover {
    color: darken($color-danger, 10%);
  }

  .calendar-popup {
    background: #f7f7f7;
    color: $color-text-primary;
    border: 2px solid $color-text-primary;
    border-radius: 4px;
    box-shadow: 0px 1px 2px rgba(39, 58, 77, 0.25);
    padding: 8px;
    pointer-events: auto;
  }

  .entry-time {
    font-size: 0.75rem;
    opacity: 30%;
  }

  .entry-actions {
    position: absolute;
    top: 4px;
    right: 4px;

    .action-icon {
      padding: 2px;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      color: $color-primary-dark;
      opacity: 60%;
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover {
        opacity: 1;
      }
    }
  }

  .entry-conflicts {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid $color-border-primary;
    font-size: 0.75rem;

    .conflicts-title {
      color: $color-danger;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .conflict-item {
      margin-bottom: 2px;
      display: flex;
      align-items: center;

      .conflict-type {
        color: $color-text-secondary;
        margin-right: 4px;
      }

      .conflict-name {
        color: $color-text-primary;
      }
    }
  }
  /* gleiche Feldbreite für beide Selects */
  .select-wrap {
    min-width: 100px;
    max-width: 150px;
  }
  .multi-select-wrap {
    width: 224px; /* gleiche Breite wie die Felder darüber */
    min-width: 224px;
    max-width: 224px;
  }

  /* vue-select intern auf Containerbreite zwingen */
  ::v-deep .v-select {
    width: 100%;
  }

  ::v-deep .v-select .vs__dropdown-toggle {
    width: 100%;
  }

  /* Dropdown genau so breit wie das Feld machen */
  ::v-deep .v-select .vs__dropdown-menu {
    left: 0;
    right: 0;
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden; /* verhindert horizontales Scrollen bei langen Labels */
    z-index: 100;
  }

  /* optional: lange Optionen umbrechen statt die Breite zu sprengen */
  ::v-deep .v-select .vs__dropdown-option {
    white-space: normal; /* sonst ist nowrap Standard */
  }

  /* Header: vergangene Tage */
  .visual-planner-header .interval-column-head.is-past {
    background-color: rgba(0, 0, 0, 0.03);
    color: $color-text-secondary;
  }

  /* Body als Positionierungs-Container */
  .visual-planner-body {
    position: relative;
  }

  /* Spalten-Overlay (graut Vergangenheit) */
  .interval-column-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    border-left: 1px solid $color-border-primary;
    pointer-events: none;
    // gleiche Layer-Ebene wie Hintergrundzeilen
    z-index: 5;
  }
  .interval-column-bg.is-past {
    background-color: rgba(0, 0, 0, 0.03);
  }

  /* Aktuelle Zeit (Linie + Punkt) */
  /* links: gestrichelt */
  .now-line-left {
    position: absolute;
    left: 0;
    height: 0; /* nur Linie via border */
    border-top: 2px dashed $red-transparent;
    pointer-events: none;
    z-index: 40;
  }

  /* rechts: durchgezogen */
  .now-line-right {
    position: absolute;
    right: 0; /* bis ganz rechts */
    height: 0;
    border-top: 2px solid $red-transparent;
    pointer-events: none;
    z-index: 40;
  }

  /* Punkt */
  .now-bullet {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 9999px;
    background: $red-transparent;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 41;
  }
</style>
